import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import {
  Actions,
  AppArea,
  MostScheduledJobListFilterInput,
  MostScheduledJobsDocument,
  MostScheduledJobsQuery,
  Subjects,
} from 'src/graphql/generated/graphql';
import { MostScheduledJobsTable } from './table';
import { useTable } from 'src/hooks/use-table';
import { Can } from 'src/utils/can';

const PAGINATION_LIMIT = 20;

type MostScheduledJobListProps = {
  filter: MostScheduledJobListFilterInput;
};

export const MostScheduledJobList = ({ filter }: MostScheduledJobListProps) => {
  const { page, setPage } = useTable<
    MostScheduledJobListFilterInput,
    Record<any, any>
  >();

  const [totalCount, setTotalCount] = useState(0);

  const { loading, data } = useQuery<MostScheduledJobsQuery>(
    MostScheduledJobsDocument,
    {
      variables: {
        filter: {
          storeIds: filter.storeIds,
          search: filter.search,
          userId: filter.userId,
        },
        pagination: {
          limit: PAGINATION_LIMIT,
          offset: page * PAGINATION_LIMIT,
        },
      },
      onCompleted: (data) =>
        setTotalCount(data?.mostScheduledJobs?.pagination?.totalCount),
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-and-network',
    },
  );
  const records = data?.mostScheduledJobs?.records || [];

  return (
    <Can I={Actions.Read} a={Subjects.Jobs} appArea={AppArea.Most}>
      <MostScheduledJobsTable
        data={records}
        className="mt-4"
        loading={loading}
        options={{
          page,
          count: totalCount,
          sort: true,
          rowsPerPage: PAGINATION_LIMIT,
          onChangePage: setPage,
          enableNestedDataAccess: '.',
        }}
      />
    </Can>
  );
};
